import { CwtCacheConfig } from "@cawita/core-front/api";

export const CacheConfig: CwtCacheConfig = {
    useTTL: true,
    ttl: {
        // '*' : -1 // Change value to set ttl for ALL routes; -1 for "infinite" cache
    }
}